type Block = { type: string; text?: string; items?: string[] };

type ArticleBodyProps = {
  blocks: Block[];
};

export default function ArticleBody({ blocks }: ArticleBodyProps) {
  return (
    <div className="flex flex-col gap-5">
      {blocks.map((block, index) => {
        if (block.type === "h2" && block.text) {
          return (
            <h2
              key={index}
              className="mt-4 flex items-center gap-3 font-heading text-xl font-black text-foreground-950 md:text-2xl"
            >
              <span className="h-5 w-1 flex-shrink-0 rounded-full bg-primary-500" aria-hidden="true" />
              {block.text}
            </h2>
          );
        }
        if (block.type === "quote" && block.text) {
          return (
            <blockquote
              key={index}
              className="rounded-lg border-l-4 border-accent-500 bg-accent-50 px-5 py-4 text-sm leading-relaxed text-foreground-800 md:text-[15px]"
            >
              <i className="ri-double-quotes-l mr-1 text-accent-600" aria-hidden="true" />
              {block.text}
            </blockquote>
          );
        }
        if (block.type === "list" && block.items) {
          return (
            <ul key={index} className="flex flex-col gap-3 rounded-lg bg-background-100 p-5">
              {block.items.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-800 md:text-[15px]">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[7px] text-primary-500" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        if (block.text) {
          return (
            <p key={index} className="text-[15px] leading-[1.9] text-foreground-700 md:text-base">
              {block.text}
            </p>
          );
        }
        return null;
      })}
    </div>
  );
}